import { render, staticRenderFns } from "./layRemark.vue?vue&type=template&id=a9a941aa&scoped=true"
import script from "./layRemark.vue?vue&type=script&lang=js"
export * from "./layRemark.vue?vue&type=script&lang=js"
import style0 from "./layRemark.vue?vue&type=style&index=0&id=a9a941aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a941aa",
  null
  
)

export default component.exports